export const ORDER_BY = {
  ASC: 'ASC',
  DESC: 'DESC'
}



// WEBPACK FOOTER //
// ./src/constants/orderBy.js